import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  viewContainer: {
    width: "100%",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    color: ({ theme }) => theme.palette.text.primary,
    marginLeft: "0.5rem",
  },
  text: {
    color: ({ theme }) => theme.palette.text.primary,
    marginBottom: "1%",
  },
  btn: {
    color: ({ theme }) => (theme.palette.mode === "light" ? "#9a0143" : "#fff"),
    fontFamily: "Rubik",
    "&:hover": {
      backgroundColor: ({ theme }) =>
        theme.palette.mode === "light" ? "rgba(128, 128, 128, 0.2)" : "#9a0143",
    },
  },
  inputText: {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
      { border: ({ theme }) => `1px solid ${theme.palette.text.primary}`, },
  },
  popup: {
    display: "flex",
    justifyContent: "center",
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "center",
    gap: "10%",
  },
  multiline: {
    whiteSpace: "pre-line",
  },
  fontBold: {
    fontWeight: "600",
  },
  titles: {
    textAlign: "justify",
    fontWeight: "600",
    padding: "5px",
  },
  roleWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "25%",
    marginTop: "1%",
  },
  back: {
    float: "right",
    width: "100px",
    height: "37px",
    background: "#5B5D6E",
    fontFamily: "Rubik",
    fontSize: "12px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#5B5D6E",
    },
  },
  pageWrapper: {
    backgroundColor: ({ theme }) => theme.palette.bgColor,
    boxShadow: "0px 5px 20px 0px rgba(0, 0, 0, 0.2)",
    borderRadius: "10px",
    paddingInline: "20px",
    fontFamily: "Rubik",
    paddingBottom: "1rem",
    display: "flex",
    justifyContent: "space-between",
    marginRight: "10px",
    marginLeft: "10px",
    flexDirection: "column",
    marginBottom: "20px",
  },
  titleWrapper: {
    width: "99%",
    marginBottom: "13px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  transferSection: {
    width: "100%",
  },
  userTypeWrapper: {
    width: "40%",
  },
  saveBtn: {
    width: "100px",
    height: "37px",
    background: "#9A0143",
    fontFamily: "Rubik",
    fontSize: "12px",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#9A0143",
    },
  },
  actionWrapper: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  scrollBtnWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
  },
  scrollBtn: {
    backgroundColor: "#9A0143",
    color: "#fff",
    marginTop: "10px",
    fontFamily: "Rubik",
    fontSize: "12px",
    "&:hover": {
      backgroundColor: "#9A0143",
    },
  },

  inputWrapper: {
    width: "40rem",
    "&:last-child": {
      marginRight: "1.5rem",
    },
  },

  wrapper: {
    justifyContent: "flex-start",
    display: "flex",
    marginTop: "0.5rem",
    marginLeft: ({ isNavbarOpen }) => (isNavbarOpen ? "26rem" : "15rem"),
    padding: "5px"
  },
});
